import "./style.css";
import { defineComponent as o, defineAsyncComponent as r, resolveComponent as n, openBlock as a, createBlock as c, withCtx as i, renderSlot as p } from "vue";
import { g as s, a as l } from "./get-block-properties-a19LfOQA.js";
import { f as m } from "./index-buEOnV4i.js";
const d = () => import("./index-buEOnV4i.js").then((e) => e.G).then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component DynamicRenderer at ../../dynamic-renderer/dynamic-renderer.vue",
    e
  ), e;
}), f = o({
  name: "block-wrapper",
  components: { DynamicRenderer: r(d) },
  props: ["Wrapper", "block", "context"],
  data() {
    return { getBlockActions: s, getBlockProperties: l };
  }
});
function u(e, k, b, y, S, g) {
  const t = n("dynamic-renderer");
  return a(), c(t, {
    TagName: e.Wrapper,
    attributes: e.getBlockProperties({
      block: e.block,
      context: e.context
    }),
    actionAttributes: e.getBlockActions({
      block: e.block,
      rootState: e.context.rootState,
      rootSetState: e.context.rootSetState,
      localState: e.context.localState,
      context: e.context.context,
      stripPrefix: !0
    })
  }, {
    default: i(() => [
      p(e.$slots, "default")
    ]),
    _: 3
  }, 8, ["TagName", "attributes", "actionAttributes"]);
}
const w = /* @__PURE__ */ m(f, [["render", u]]);
export {
  w as default
};
